export const emotions = [
  "Happiness",
  "Sadness",
  "Anger",
  "Fear",
  "Surprise",
  "Disgust",
  "Contempt",
  "Trust",
  "Anticipation",
  "Joy",
  "Love",
  "Anxiety",
  "Boredom",
  "Pride",
  "Shame",
  "Guilt",
  "Excitement",
  "Relief",
  "Confusion",
  "Calmness"
];

export function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}
